<script lang="ts">
export default {
  name: 'KkStatusLabel',
}
</script>

<script lang="ts" setup>
export interface Props {
  status: '1' | '2' | '3' | 1 | 2 | 3
  text: string
  syncTextColor?: boolean
}

const props = defineProps<Props>()
</script>

<template>
  <div class="statusLabel">
    <span class="statusLabel__mark" :class="`statusLabel__mark--${props.status}`" />
    <p :class="{ [`statusLabel__text--${props.status}`]: props.syncTextColor }">
      {{ props.text }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/var";
.statusLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  &__mark {
    flex: 0 0 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    // あえて番号で管理して意味を持たせない
    &--1 {
      background: $complete-color;
    }
    &--2 {
      background: $color-accent-primary;
    }
    &--3 {
      background: #D2D5DB;
    }
  }
  &__text {
    // あえて番号で管理して意味を持たせない
    &--1 {
      color: $complete-color;
    }
    &--2 {
      color: $color-accent-primary;
    }
    &--3 {
      color: #D2D5DB;
    }
  }
}
</style>
